// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Heading_wrapper__PiV0g","darkMode":"Heading_darkMode__A0RYZ"};